import { render } from "./RecoveryPassword.vue?vue&type=template&id=935e4418"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/RecoveryPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "935e4418"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('935e4418', __exports__)) {
    api.reload('935e4418', __exports__)
  }
  
  module.hot.accept("./RecoveryPassword.vue?vue&type=template&id=935e4418", () => {
    api.rerender('935e4418', render)
  })

}


export default __exports__